import PropertyAssessmentLoadable from 'containers/PropertyAssessment/Loadable';
import ROUTES, { routesNames } from './constants';

const createPropertyAssessmentRoutes = () => [
  {
    path: ROUTES.PROPERTY_ASSESSMENT(),
    name: routesNames.propertyAssessmentSection,
    component: PropertyAssessmentLoadable,
  },
  {
    path: ROUTES.PROPERTY_ASSESSMENT_SECTION(),
    name: routesNames.propertyAssessmentSection,
    component: PropertyAssessmentLoadable,
  },
];

export default createPropertyAssessmentRoutes;
